module.exports = __webpack_public_path__ + "img/content-1.9bfc8026.png";